import MiniBasket from './lib/js/MiniBasket';

export default MiniBasket;
